import type { Account } from '@shared/products-types';
import type { Transaction } from '@shared/transactions-types';
import type { ProductWithHelpers } from '@shared/products-core';
import { useCards } from '@shared/cards-core';
import { useProducts } from '@retail/products-core';

import { getOwnerAccount } from './GettingAccountsForTransactions';

export function useOwnerAccountForTransaction(
    transaction?: Transaction,
): ProductWithHelpers<Account> | undefined {
    const { products } = useProducts();
    const { cards } = useCards();
    if (!transaction) {
        return undefined;
    }
    const { owner, cardId } = transaction;
    return getOwnerAccount(products, cards, owner, cardId);
}
